<template>
  <div class="main-box clinic-flags-box" v-loader.opacity.tab="loading">
    <BaseTable
      class="no-border"
      v-if="tableFlags && tableFlags.items?.length"
      :tabledata="tableFlags">
      <template v-slot:column_enabled="{item}">
        <div class="form-floating">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch"
              :id="`flag_${item.key}`"
              :data-test="`switchFlag_${item.key}`"
              v-model="item.enabled"
              @change="doToggleFlag(item)"/>
          </div>
        </div>
      </template>
    </BaseTable>

    <div class="no-results-box" v-else>
      <BaseNoResults :title="$t('request_notfound_title')" :text="$t('clinicFlags.noFlags')"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-box {
  padding:                       0 10px 10px 10px;
}

@media (min-width: 992px) {
  .main-box {
    overflow:                      hidden;
  }
}

.form-floating {
  display:                       flex;
  justify-content:               center;

  .form-check {
    border:                      none;
    background:                  transparent;
    padding:                     0;
    width:                       auto;
  }
}
</style>

<script>
export default {
  name: 'ClinicFlagsTab',
  props: {
    clinic_id: { type: [String, Number] },
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    tableFlags: null,
  }),
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      await this.$helpers.requestHandling(async () => {
        const response = await this.$clinicService.getManageableFlags({clinicId: this.clinic_id})
        const items = (response.result || []).map(flag => ({...flag, id: flag.key}))

        this.tableFlags = {
          items,
          total: items.length,
          columns: [
            { name: this.$i18n.t('clinicFlags.key'), type: 'string', value: 'key', width: '30%' },
            { name: this.$i18n.t('clinicFlags.description'), type: 'string', value: 'description', width: '55%' },
            { key: 'enabled', name: this.$i18n.t('clinicFlags.enabled'), type: 'custom', value: 'enabled', width: '15%', align: 'text-center' },
          ]
        }
      }, this, 'clinicFlags.loadError');
    },
    async doToggleFlag(item) {
      await this.$helpers.requestHandling(async () => {
        await this.$clinicService.updateManageableFlag({
          clinicId: this.clinic_id,
          feature: item.key,
          enabled: item.enabled
        })

        this.$message.popup(this, 'clinicFlags.saveSuccess', 'operationSuccess', 'success')

        await this.$authService.refreshSession(this)
      }, this, 'clinicFlags.saveError');
    },
  }
}
</script>
